import React from "react";
import Helmet from "react-helmet";
import Main from "../../components/main";
import Box from "../../components/box";
import H1 from "../../components/h1";
import P from "../../components/p";

class AboutUs extends React.PureComponent {
  // componentDidMount() {
  //   const desktop = document.getElementById("twitter-quote-trustbox-desktop");
  //   const loadFromElement = () => {
  //     if (window.Trustpilot) {
  //       window.Trustpilot.loadFromElement(desktop);
  //     } else {
  //       setTimeout(loadFromElement, 500);
  //     }
  //   };
  //   loadFromElement();
  // }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <Main>
        <Helmet>
          <title>About Us</title>
          <meta
            name="description"
            content="If you want to learn more about our website, you can click this link right here and find out more about Ghast"
          />
        </Helmet>
        <Box>
          <H1>About Us</H1>
          <P>
            Ghast is a product created to help you optimize your connection for
            minecraft pvp, we launched in 2018 and have been improving our
            product and service ever since. We are happy to have you along as
            part of this journey.
          </P>
          <P>
            AuraSide, Inc. is a company on a mission - to make the best tools
            for helping competitive gamers and esports teams - we have a lot of
            work ahead of us and Ghast.io is only the start!
          </P>
          <P>
            The founder of Ghast.io initially created Ghast for himself over the
            process of a year or two. Slowly improving on it and adding
            different features and settings. It was a hard decision for him to
            open the product up for everyone, since he loved being the only one
            with such a good connection, he loved having it all to himself.
          </P>
          {/* <div
            id="twitter-quote-trustbox-desktop"
            className="trustpilot-widget"
            data-locale="en-GB"
            data-template-id="53aa8912dec7e10d38f59f36"
            data-businessunit-id="5c3cae791aa59c0001976ef2"
            data-style-height="130"
            data-style-width="100%"
            data-theme="light"
            data-stars="4,5"
            data-schema-type="Organization"
            style={{ marginTop: 100, marginBottom: 60 }}
          >
            {" "}
            <a href="https://uk.trustpilot.com/review/ghast.io" target="_blank">
              Trustpilot
            </a>{" "}
          </div> */}
        </Box>
      </Main>
    );
  }
}

export default AboutUs;



/** WEBPACK FOOTER **
 ** ./src/views/pages/about-us/index.js
 **/